import { useEffect, useState } from "react";
import { CommonHeader } from "../../../components/commons";
import "./style.scss";
import GeneralSettingSideMenu from "../../../components/ClientSettings/GeneralSetting/GeneralSettingSideMenu";
import GeneralSettingContentArea from "../../../components/ClientSettings/GeneralSetting/GeneralSettingContentArea";
import { connect } from "react-redux";
import { RootState } from "../../../redux/rootReducers";
import { resetSession } from "../../../redux/auth";
import {
  resetClientSettingsError,
  resetClientSettingsSuccess,
  resetMessage,
} from "../../../redux/clientSettings";
import { resetMasterStatusCode } from "../../../redux/masterData";
import toast from "react-hot-toast";
type AppProps = {
  history?: any;
  dispatchResetSession: () => void;
  dispatchResetClientSettingMessage: () => void;
  dispatchResetMasterStatusCode: () => void;
  dispatchResetClientSettingsSuccess: () => void;
  dispatchResetClientSettingsError: () => void;
};

const GeneralSetting = ({
  history,
  dispatchResetSession,
  dispatchResetClientSettingMessage,
  dispatchResetMasterStatusCode,
  dispatchResetClientSettingsSuccess,
  dispatchResetClientSettingsError,
}: AppProps) => {
  const clientCode = history?.location?.state?.client_code;
  const companyName = history?.location?.state?.company_name;
  const [menuName, setMenuName] = useState<string>("Sales Templates");

  const handleMenuNameChange = (name: string) => {
    toast.dismiss()
    setMenuName(name);
  };

  useEffect(() => {
    toast.dismiss()
    dispatchResetClientSettingMessage()
    dispatchResetMasterStatusCode()
    dispatchResetClientSettingsSuccess()
    dispatchResetClientSettingsError()
    return () => toast.dismiss()
  }, [])

  return (
    <div>
      <CommonHeader
        title={`General Setting`}
        company_name={companyName}
        client_code={clientCode}
      />

      <div className="mt-2 general_setting">
        <div className="d-flex">
          <GeneralSettingSideMenu
            menuName={menuName}
            handleMenuNameChange={handleMenuNameChange}
          />

          <GeneralSettingContentArea history={history} menuName={menuName} />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetClientSettingMessage: () => dispatch(resetMessage()),
  dispatchResetMasterStatusCode: () => dispatch(resetMasterStatusCode()),
  dispatchResetClientSettingsSuccess: () =>
    dispatch(resetClientSettingsSuccess()),
  dispatchResetClientSettingsError: () => dispatch(resetClientSettingsError()),
});

export default connect(mapStateToProps, mapDispatchToProps)(GeneralSetting);
